import { Autocomplete } from 'src/components/Autocomplete';
import { TextField } from 'src/components/TextField';

interface CombinedOption {
  id: boolean | null;
  name: string;
}

interface CombinedFilterProps {
  label: string;
  value: string | undefined;
  setValue: (newVal: string) => void;
  valueOnly?: boolean;
}

const combinedOptions: CombinedOption[] = [
  { id: null, name: 'Individual' },
  { id: true, name: 'Aggregate' },
];

export const CombinedFilter: React.FC<CombinedFilterProps> = ({
  label,
  value,
  setValue,
  valueOnly,
}) => {
  const selectedOption = combinedOptions.find(
    (o) => o.id === (String(value) === 'true' ? true : null)
  );

  if (valueOnly) {
    return <>{selectedOption?.name || ''}</>;
  }

  return (
    <Autocomplete
      options={combinedOptions}
      getOptionLabel={(option) => option.name}
      value={selectedOption || null}
      onChange={(_, newValue) => {
        setValue(newValue?.id?.toString() || '');
      }}
      renderInput={(params) => (
        <TextField {...params} label={label} placeholder="Select View Type" />
      )}
    />
  );
};
